import AdminHeader from "@/components/AdminHeader";
import AdminHero from "@/components/AdminHero";
import VenueGallerySlider from "@/components/admin/VenueGallerySlider";
import DashboardSneakPeek from "@/components/admin/DashboardSneakPeek";
import AdminCTA from "@/components/AdminCTA";
import Footer from "@/components/Footer";

const AdminLanding = () => {
  console.log("AdminLanding component is rendering");
  
  return (
    <div className="min-h-screen bg-black flex flex-col">
      <AdminHeader />
      <main className="flex-grow pt-20">
        <AdminHero />
        <VenueGallerySlider />
        <DashboardSneakPeek />
        <AdminCTA />
      </main>
      <Footer />
    </div>
  );
};

export default AdminLanding;
